var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/feature/connections/NotForSale/BarGraphShowcaseUpsell/BarGraphShowcaseUpsellTemplate.jsx";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import PropTypes from 'prop-types';
import marked from 'marked';
import styled from 'styled-components';
import { Box, Button, Flex, Heading, Paragraph, Popover, Text, TextButton } from '@zillow/constellation';
import BarGraphPricePill from './BarGraphPricePill';
import { formatHomePrice, formatEarnings } from '../../../../../utils/currencyFormatting';
import { ShowcaseMarkDownTextWithToolTip } from '../DualHookShowcaseUpsell/ShowcaseMarkDownTextWithToolTip';

function calculateOfferValues(standingOfferPrice) {
  if (standingOfferPrice) {
    var zestimatePrice = parseInt(standingOfferPrice, 10);
    var showcasePrice = zestimatePrice * 0.02 + zestimatePrice;
    var expectedEarnings = showcasePrice - zestimatePrice;
    return [zestimatePrice, showcasePrice, expectedEarnings];
  }

  return null;
}

var MaxWidthWrapper = styled(Flex).withConfig({
  displayName: "BarGraphShowcaseUpsellTemplate__MaxWidthWrapper",
  componentId: "sc-1rjwlub-0"
})(["max-width:250px;min-width:135px;"]);

var BarGraphShowcaseUpsellTemplate = function BarGraphShowcaseUpsellTemplate(_ref) {
  var titleMarkdownText = _ref.titleMarkdownText,
      bodyMarkdownText = _ref.bodyMarkdownText,
      standingOfferPrice = _ref.standingOfferPrice,
      actionText = _ref.actionText,
      firstBarGraphMarkdownText = _ref.firstBarGraphMarkdownText,
      firstBarGraphTooltipHeading = _ref.firstBarGraphTooltipHeading,
      firstBarGraphTooltipBody = _ref.firstBarGraphTooltipBody,
      firstBarGraphTooltipButtonText = _ref.firstBarGraphTooltipButtonText,
      firstBarGraphTooltipButtonActionLink = _ref.firstBarGraphTooltipButtonActionLink,
      onActionButtonClick = _ref.onActionButtonClick,
      secondBarGraphText = _ref.secondBarGraphText;

  var _calculateOfferValues = calculateOfferValues(standingOfferPrice),
      _calculateOfferValues2 = _slicedToArray(_calculateOfferValues, 3),
      zestimatePrice = _calculateOfferValues2[0],
      showcasePrice = _calculateOfferValues2[1],
      expectedEarnings = _calculateOfferValues2[2];

  var formattedZestimatePrice = formatHomePrice(zestimatePrice);
  var formattedShowcasePrice = formatHomePrice(showcasePrice);
  var formattedExpectedEarnings = formatEarnings(expectedEarnings);
  var titleText = /*#__PURE__*/React.createElement(Heading, {
    level: 4,
    marginTop: {
      default: 0,
      sm_lte: 2
    },
    dangerouslySetInnerHTML: {
      __html: marked.parseInline(titleMarkdownText)
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 9
    }
  });
  var firstBarGraphTextPopover = /*#__PURE__*/React.createElement(Popover, {
    modal: false,
    header: /*#__PURE__*/React.createElement(Heading, {
      level: "6",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 68,
        columnNumber: 21
      }
    }, firstBarGraphTooltipHeading),
    body: /*#__PURE__*/React.createElement(React.Fragment, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Paragraph, {
      fontType: "body",
      marginBottom: 2,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 71,
        columnNumber: 21
      }
    }, firstBarGraphTooltipBody), /*#__PURE__*/React.createElement(TextButton, {
      fontColor: "blue500",
      as: "a",
      href: firstBarGraphTooltipButtonActionLink,
      target: "_blank",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 74,
        columnNumber: 21
      }
    }, firstBarGraphTooltipButtonText)),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 9
    }
  });
  var firstBarGraphMarkdownTextNode = /*#__PURE__*/React.createElement(ShowcaseMarkDownTextWithToolTip, {
    markdownTextInput: firstBarGraphMarkdownText,
    bodyTooltipPopover: firstBarGraphTextPopover,
    fontType: "bodySmallHeading",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 9
    }
  });
  var actionButton = /*#__PURE__*/React.createElement(Button, {
    buttonType: "primary",
    onClick: onActionButtonClick,
    fluid: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 96,
      columnNumber: 9
    }
  }, actionText);
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      'display': 'flex',
      'flexDirection': 'column',
      'backgroundColor': '$colors.white',
      'maxWidth': '450px',
      'padding': '24px 10px 12px',
      '@media $sm': {
        padding: '24px 16px 12px'
      },
      'margin': '0 auto'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 102,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    flexDirection: "row",
    marginBottom: {
      default: 3,
      sm_lte: 2
    },
    justifyContent: "space-between",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 115,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(MaxWidthWrapper, {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    gap: 2,
    flexGrow: 1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 121,
      columnNumber: 17
    }
  }, titleText, /*#__PURE__*/React.createElement(Text, {
    fontType: "h3",
    as: "h3",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 129,
      columnNumber: 21
    }
  }, formattedExpectedEarnings), /*#__PURE__*/React.createElement(Text, {
    as: "p",
    fontType: {
      default: 'body',
      sm_lte: 'bodySmall'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 132,
      columnNumber: 21
    }
  }, bodyMarkdownText)), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    alignItems: "flex-end",
    marginTop: 3,
    flexShrink: 1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 136,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 137,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(BarGraphPricePill, {
    homePrice: formattedZestimatePrice,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 138,
      columnNumber: 25
    }
  }), /*#__PURE__*/React.createElement(Box, {
    sx: {
      backgroundColor: '$colors.blue200',
      borderRadius: '8px 8px 0px 0px',
      height: '90px',
      width: '42px'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 139,
      columnNumber: 25
    }
  }), firstBarGraphMarkdownTextNode), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 149,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(BarGraphPricePill, {
    homePrice: formattedShowcasePrice,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 150,
      columnNumber: 25
    }
  }), /*#__PURE__*/React.createElement(Box, {
    sx: {
      backgroundColor: '$colors.blue400',
      borderRadius: '8px 8px 0px 0px',
      height: '154px',
      width: '42px'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 151,
      columnNumber: 25
    }
  }), /*#__PURE__*/React.createElement(Text, {
    fontType: "bodySmallHeading",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 159,
      columnNumber: 25
    }
  }, secondBarGraphText)))), actionButton);
};

BarGraphShowcaseUpsellTemplate.propTypes = process.env.NODE_ENV !== "production" ? {
  titleMarkdownText: PropTypes.string.isRequired,
  bodyMarkdownText: PropTypes.string.isRequired,
  standingOfferPrice: PropTypes.string.isRequired,
  actionText: PropTypes.string.isRequired,
  firstBarGraphMarkdownText: PropTypes.string.isRequired,
  firstBarGraphTooltipHeading: PropTypes.string.isRequired,
  firstBarGraphTooltipBody: PropTypes.string.isRequired,
  firstBarGraphTooltipButtonText: PropTypes.string.isRequired,
  firstBarGraphTooltipButtonActionLink: PropTypes.string.isRequired,
  onActionButtonClick: PropTypes.func.isRequired,
  secondBarGraphText: PropTypes.string.isRequired
} : {};
export default BarGraphShowcaseUpsellTemplate;